import { Divider, IDividerProps } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import { SeverityType } from '@aon/tws-common-ui-questions/build/lib/models';
import * as React from 'react';
import styled from 'styled-components';
import { SurveyStep } from '../../models';
import { WarningBox } from '../common/warnings';

export interface IPageBreakRowProps {
	propertyErrors: string[];
	propertyWarnings: string[];
	linkToWarnings?: SurveyStep;
	linkToErrors?: SurveyStep;
	pageNumber: number;
	totalPages: number;
}

export const PageBreak = styled(Divider).attrs<{ props: IDividerProps }>({})`
	margin: 0 2px -2px 0;
	border-color: ${globalVars.gray1};
`;
PageBreak.displayName = 'PageBreak';

export const Pill = styled.div.attrs<{}>({
	className: 'tws-page-break-pill',
})`
	 {
		background-color: #e3e3e3;
		color: ${globalVars.gray1};
		display: inline-block;
		font-weight: ${globalVars.fontWeightBold};
		position: relative;
		border-radius: 0 0 6px 6px;
		font-size: 10px;
		height: 21px;
		padding: 0 12px;

		div {
			height: 100%;
			position: relative;
			display: flex;
			align-items: center;
		}
	}
`;
Pill.displayName = 'Pill';

export const PageBreakRow = (props: IPageBreakRowProps) => {
	const { pageNumber, totalPages, propertyErrors, propertyWarnings, linkToErrors, linkToWarnings } = props;
	return (
		<>
			<PageBreak type='dashed' />
			<Pill>
				Page {pageNumber} of {totalPages}
			</Pill>
			{propertyWarnings.length > 0 && (
				<WarningBox severity={SeverityType.Warning} messages={propertyWarnings} linkToStep={linkToWarnings} />
			)}
			{propertyErrors.length > 0 && <WarningBox severity={SeverityType.Error} messages={propertyErrors} linkToStep={linkToErrors} />}
		</>
	);
};
